import { THASH, TID } from 'types/general';
import { RBreadCrumbs, RSearch } from './types';
import request from '../../../lib/helpers/requestApi';

/** Получение сущтности по InternalID */
export const getSearchByInternalIdOrXxhash = request<RSearch, TID>({
  method: 'search.byInternalIdOrXxhash',
});

/** Получение хлебных крошек */
export const getBreadcrumbs = request<RBreadCrumbs, THASH>({
  method: 'search.getBreadCrumbs',
});
